import React from 'react';
import PropTypes from 'prop-types';
import { AppProvider } from './AppContext';
import { DarksideLayout, ErrorNoData, SelfActivationLayout } from '../Layouts';
import ConsejosBam from '../BamAdvice/ConsejosBam';
import AppControllerLogin from './AppControllerLogin';
import PATHNAME from './helpers/Pathname';
import { GlobalDataProvider } from '../../contextProvider/GlobalDataContext';

const AppRouter = ({ children, location }) => {
  const pathname = PATHNAME(location.pathname);

  // NO JWT Auth Ms
  const PublicComponentMap = {
    'auto-activable': (
      <SelfActivationLayout location={location}>
        {children}
      </SelfActivationLayout>
    ),
    'error/no-data': <ErrorNoData location={location}>{children}</ErrorNoData>,
    'consejos-bam': <ConsejosBam />,
    darkside: <DarksideLayout />,
  };

  if (pathname in PublicComponentMap) return PublicComponentMap[pathname];

  return (
    <AppProvider>
      <GlobalDataProvider>
        <AppControllerLogin location={location}>{children}</AppControllerLogin>
      </GlobalDataProvider>
    </AppProvider>
  );
};

AppRouter.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

export default AppRouter;
